import { motion } from 'framer-motion'

export default function HeroLines(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1637"
      height="514"
      {...props}
    >
      <defs>
        <linearGradient id="a" x1="100%" x2="0%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#44C751" />
          <stop offset="100%" stopColor="#FA9738" />
        </linearGradient>
        <linearGradient id="b" x1="100%" x2="0%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#F99738" />
          <stop offset="100%" stopColor="#DF49E6" />
        </linearGradient>
        <linearGradient id="c" x1="100%" x2="0%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#DF49E6" />
          <stop offset="100%" stopColor="#F99738" />
        </linearGradient>
        <linearGradient id="d" x1="100%" x2="0%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#F99738" />
          <stop offset="100%" stopColor="#DF49E6" />
        </linearGradient>
        <linearGradient id="e" x1="100%" x2="0%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#FA9738" />
          <stop offset="100%" stopColor="#44C751" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <motion.path
          fill="url(#a)"
          d="M584.905 416.387c-56.877 18.96-123.792 28.98-193.508 28.98-68.968 0-135.287-9.824-191.79-28.41-54.162-17.818-95.777-42.422-120.548-71.226l9.488 1.068.25-2.24-13.448-1.512-.533 13.515 2.255.09.366-9.353c25.05 29.074 66.979 53.872 121.466 71.796 56.726 18.66 123.29 28.524 192.494 28.524 69.955 0 137.116-10.062 194.221-29.095 55.921-18.64 98.353-44.496 122.707-74.77l-1.757-1.41c-24.083 29.936-66.153 55.54-121.663 74.043"
          transform="scale(-1 1) rotate(12 -3.875 -3333.114)"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1 }}
        />
        <motion.path
          fill="url(#b)"
          d="M321.929 55c-69.956 0-137.117 10.061-194.222 29.096C71.787 102.736 29.354 128.59 5 158.865l1.756 1.41c24.084-29.936 66.155-55.54 121.664-74.043 56.879-18.959 123.793-28.98 193.509-28.98 68.968 0 135.288 9.825 191.79 28.411 54.161 17.817 95.777 42.42 120.548 71.224l-9.488-1.068-.25 2.24 13.448 1.512.532-13.514-2.253-.09-.366 9.352c-25.05-29.072-66.979-53.871-121.466-71.795C457.697 64.864 391.134 55 321.929 55z"
          transform="rotate(10 317.776 111.528)"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        />
        <motion.path
          fill="url(#c)"
          d="M563.256 295.754c24.355 30.274 66.787 56.13 122.708 74.77 57.104 19.033 124.265 29.095 194.22 29.095 69.205 0 135.77-9.864 192.496-28.524 54.49-17.925 96.418-42.725 121.468-71.8l.365 9.359 2.254-.09-.53-13.514-13.45 1.511.25 2.24 9.483-1.067c-24.77 28.803-66.385 53.406-120.545 71.222-56.502 18.587-122.823 28.41-191.791 28.41-69.715 0-136.63-10.02-193.507-28.979-55.51-18.503-97.581-44.107-121.664-74.043l-1.757 1.41z"
          transform="scale(-1 1) rotate(-3 14.013 33965.395)"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.3 }}
        />
        <motion.path
          fill="url(#d)"
          d="M1003.256 203.754c24.355 30.274 66.787 56.13 122.708 74.77 57.104 19.033 124.265 29.095 194.22 29.095 69.205 0 135.77-9.864 192.496-28.524 54.49-17.925 96.418-42.725 121.468-71.8l.365 9.359 2.254-.09-.53-13.514-13.45 1.511.25 2.24 9.483-1.067c-24.77 28.803-66.385 53.406-120.545 71.222-56.502 18.587-122.823 28.41-191.791 28.41-69.715 0-136.63-10.02-193.507-28.979-55.51-18.503-97.581-44.107-121.664-74.043l-1.757 1.41z"
          transform="rotate(-160 1320.386 255.302)"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4 }}
        />
        <motion.path
          fill="url(#e)"
          d="M894.575 91c-35.702 0-70.053 9.867-99.338 28.536-27.983 17.838-49.568 42.483-62.547 71.364l-3.001-8.864-2.135.723 4.34 12.81 12.47-5.257-.876-2.077-8.796 3.71c12.793-28.533 34.106-52.883 61.757-70.51 28.923-18.437 62.853-28.183 98.126-28.183 35.728 0 70.022 9.979 99.175 28.856 28.485 18.448 50.084 43.999 62.463 73.892l2.083-.86c-12.554-30.318-34.45-56.225-63.321-74.921C965.457 101.104 930.739 91 894.575 91z"
          transform="translate(.615 .75)"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
        />
      </g>
    </svg>
  )
}
